import cloneDeep from 'lodash/cloneDeep'
import { Reducer, Action } from 'redux'
import { ICarrierVinState, IVin } from 'types/carrier'
import {
  VINS_ACTION_TYPES,
  VINS_EDIT_ACTION_TYPES,
  VINS_SAVE_ACTION_TYPES,
  VINS_DIALOG_ACTION_TYPES,
} from 'apps/carrier/utils/actions/carrierVins'

const { VINS_FAILURE, VINS_REQUEST, VINS_SUCCESS } = VINS_ACTION_TYPES

const { ADD_VIN, DELETE_VIN } = VINS_EDIT_ACTION_TYPES

const { VINS_SAVE_FAILURE, VINS_SAVE_REQUEST, VINS_SAVE_SUCCESS } = VINS_SAVE_ACTION_TYPES

const { CLOSE_VINS_DIALOG, OPEN_VINS_DIALOG } = VINS_DIALOG_ACTION_TYPES

const defaultState = {
  vins: [],
  vinsBackup: undefined,
  loading: false,
  saving: false,
  error: undefined,
  showDialog: false,
} as ICarrierVinState

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {
  payload: {
    scheduledVins: IVin[]
  }
}

interface IEditAction extends Action<string> {
  vin: IVin
}

interface IAddAction extends Action<string> {
  vin: string
}

type CarrierVinsAction = Action<string> | IErrorAction | ISuccessAction | IAddAction

const carrierVinsReducer: Reducer<ICarrierVinState, CarrierVinsAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case VINS_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case VINS_SUCCESS:
      return {
        ...state,
        loading: false,
        vins: (action as ISuccessAction).payload.scheduledVins,
      }

    case VINS_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action as IErrorAction).error,
      }

    case OPEN_VINS_DIALOG:
      return {
        ...state,
        showDialog: true,
        vinsBackup: cloneDeep(state.vins),
      }

    case CLOSE_VINS_DIALOG:
      return {
        ...state,
        showDialog: false,
        vins: state.vinsBackup || [],
        vinsBackup: undefined,
      }

    case ADD_VIN: {
      const { vin } = action as IAddAction
      const existing = state.vins.find(entry => entry.vin === vin)
      return {
        ...state,
        vins: existing
          ? state.vins.map(entry =>
              entry.vin === existing.vin ? { ...entry, _destroy: undefined } : entry
            )
          : [...state.vins, { vin }],
      }
    }

    case DELETE_VIN: {
      const { vin } = action as IEditAction
      return {
        ...state,
        vins: vin.id
          ? state.vins.map(entry => (entry.id === vin.id ? { ...entry, _destroy: true } : entry))
          : state.vins.filter(entry => entry.vin === vin.vin),
      }
    }

    case VINS_SAVE_REQUEST:
      return {
        ...state,
        saving: true,
      }

    case VINS_SAVE_SUCCESS:
      return {
        ...state,
        vins: (action as ISuccessAction).payload.scheduledVins,
        vinsBackup: undefined,
        showDialog: false,
        saving: false,
      }

    case VINS_SAVE_FAILURE:
      return {
        ...state,
        saving: false,
        error: (action as IErrorAction).error,
      }

    default:
      return state
  }
}

export default carrierVinsReducer
